export const REDIRECT_STORAGE_KEY = "loginRedirectTo"
